import {
  Agendamiento,
  IDataPreventa,
  IDataProspecto,
  IPreagendamiento,
} from '@/shared/interfaces';

export type AprovePreagendamientoData = Pick<
  IPreagendamiento,
  'estado_preagendamiento'
> &
  Pick<
    IDataPreventa,
    | 'persona_referencia_nombre'
    | 'persona_referencia_parentesco'
    | 'persona_referencia_celular'
    | 'provincia'
    | 'ciudad'
    | 'zona'
    | 'sector'
    | 'direccion'
  > &
  Pick<IDataProspecto, 'pais'> &
  Pick<
    Agendamiento,
    | 'estado_llamada'
    | 'observaciones'
    | 'fecha_hora_llamada'
    | 'email'
    | 'celular'
    | 'celular_2'
    | 'fecha_instalacion'
    | 'hora_instalacion'
    | 'coordenadas'
    | 'nap'
    | 'distancia'
    | 'flota'
  > & {
    motivo_rechazo?: string | null;
    observacion_rechazo?: string | null;
    user_gestionando?: string | null;
    cantidad_reversos?: number;
  };

export type RejectPreagendamientoData = Pick<
  IPreagendamiento,
  'motivo_rechazo' | 'estado_preagendamiento'
>;

export type PreagendamientoOcupado = Pick<
  IPreagendamiento,
  'user_gestionando'
>

export type PreagendamientoCambioEstado = Pick<
  IPreagendamiento,
  'estado_preagendamiento'
>

///* install schedule --------------------
export type InstallScheduleData = {
  selectedHour: number;
  selectedDate: string; // date

  limitDate: string; // timestamp - 10 mins - timer

  userId: string | number;
  preventaId: string | number;

  flotaCode: string;

  // helpers
  flotaName: string;
  isVisibleCalendario?: boolean;
} | null;

///* Set Cache - Horario Instalacion
export enum CacheKeysPreventaEnum {
  HORARIO_INSTALACION_PREAGENDA_BASE = 'horario_instalacion_preagenda',
  HORARIO_INSTALACION_AGENDA_PYL_BASE = 'horario_instalacion_agenda_pyl',
  HORARIO_INSTALACION_AGENDA_RECOORDINADA_BASE = 'horario_instalacion_agenda_recoordinada',
}

export type BlockHourPlanificadorPreagendaData = {
  id_preventa: number; // fk
  flota: string; // code
  fecha: string;
  horas: number[];
  tiempo: string; // "HH:mm" - "00:10" // tiempo bloqueo
  motivo?: string;
};

export enum HorarioAgendamientoEnum {
  // initialCountMinutes = 0.35, // approximately 21 seconds
  // initialCountSeconds = 21, // 21 seconds

  // initialCountMinutes = 0.1667, // approximately 10 seconds
  // initialCountSeconds = 10, // 10 seconds

  initialCountMinutes = 1, // 1 minutes
  initialCountSeconds = 60, // 10 minutes
}

///* preagendas actualizadas x tecnico --------------------
export type MarkAsReviwedPreagendamientoData = Pick<
  IPreagendamiento,
  'revisado_pyl' | 'fecha_revision_pyl'
>;
